<script>
import StringUtils from '@/utils/stringUtils'
import StatusServices from '@/services/status'
import AsyncUtils from '@/utils/asyncUtils'

export default
{
    name: 'fatal-error',

    props:
    {
        message: { type: String, default: '' }
    },

    created ()
    {
        if (StringUtils.isEmptyString(this.message))
        {
            this.errorMessage = this.$route.query.message
        }
        else this.errorMessage = this.message
    },

    render () 
    {
        return (
            <div id='fatal-error-view'>
                <img id='image' src={require('@/assets/img/emoji-construction-sign.png')} on-click={this.onImageClicked} />
                <div id='title'>Erreur fatale</div>
                <div id='message' v-show={this.errorMessage}>{ this.errorMessage }</div>
                <img id='funny-gif' src={require('@/assets/img/funny-dog.gif')} />
                {
                    /* <div id='generic-message'>
                        Nous sommes vraiment désolés, nous travaillons dessus. Essayez de relancer l'application plus tard. Voici un GIF pour vous aider à patienter.
                    </div> */
                }
            </div>
        )
    },

    mounted ()
    {
        setTimeout(this.$toast.clear, 200)
        this.tryReconnect()
    },

    data () 
    {
        return {
            errorMessage: undefined,
            imageClickedCount: 0
        }
    },

    computed:
    {
    },

    methods:
    {
        onImageClicked ()
        {
            this.imageClickedCount += 1

            if (this.imageClickedCount >= 5)
            {
                this.$router.replace('/home')
            }
        },

        async tryReconnect ()
        {
            try
            {
                await StatusServices.getApiStatus()
                await this.$router.push('/home')
            }
            catch (e)
            {
                console.error('Could not refresh', e)
                await AsyncUtils.sleep(5000)
                this.tryReconnect()
            }
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#fatal-error-view
{
    background-color: var(--theme-background-color);
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--theme-text-color-lighter);
    text-align: center;

    #image
    {
        height: 8vh;
        margin-top: -46vh;
    }

    #title
    {
        font-size: 4vh;
        margin-top: 5vh;
        font-weight: bolder;
        text-transform: uppercase;
        font-family: Inter;
    }

    #message
    {
        font-size: 2.5vh;
        margin-top: 2vh;
        margin-left: 6%;
        margin-right: 6%;
    }

    #funny-gif
    {
        position: absolute;
        bottom: 14vh;
    }

    #generic-message
    {
        font-size: 1.7vh;
        position: absolute;
        bottom: 5vh;
        width: 88%;

        .OnDesktop({ bottom: 10vh });
    }
}
</style>


// WEBPACK FOOTER //
// src/views/FatalError.vue